import { render } from "./imagenSegunda_ingles.vue?vue&type=template&id=84886aac&scoped=true"
import script from "./imagenSegunda_ingles.vue?vue&type=script&lang=js"
export * from "./imagenSegunda_ingles.vue?vue&type=script&lang=js"

import "./imagenSegunda_ingles.vue?vue&type=style&index=0&id=84886aac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84886aac"]])

export default __exports__